module.exports = __webpack_public_path__ + "static/2.2-edc07ce8e073fd82b5e8c04d770ee0ed.jpg";